import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const HorizontalCardListFocus = styled.div<React.CSSProperties>`
  border: ${4 * Screen.widthRatio}px solid white;
  border-radius: ${24 * Screen.widthRatio}px;
  height: ${197 * Screen.widthRatio}px;
  position: absolute;
  width: ${350 * Screen.widthRatio}px;
`;

export default HorizontalCardListFocus;
